import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "leaderboard-container"
};
const _hoisted_2 = { class: "leaderboard" };
const _hoisted_3 = { class: "leaderboard-list" };
const _hoisted_4 = { class: "position" };
const _hoisted_5 = { class: "position-number" };
const _hoisted_6 = {
    key: 0,
    class: "trophy"
};
const _hoisted_7 = {
    key: 1,
    class: "trophy"
};
const _hoisted_8 = {
    key: 2,
    class: "trophy"
};
const _hoisted_9 = { class: "player-info" };
const _hoisted_10 = { class: "player-name" };
const _hoisted_11 = { class: "player-points" };
const _hoisted_12 = {
    key: 0,
    class: "user-badge"
};
const _hoisted_13 = { class: "user-stats" };
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi } from '@/composables/useApi';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AchievementsLeaderBoardPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const api = useApi();
        const leaderboardEntries = ref(null);
        function getPoints(onSuccess = null) {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/Achievements/Points", (result) => {
                state.points = result;
                if (onSuccess)
                    onSuccess();
            }, false);
        }
        function generateLeaderboard() {
            const userPosition = state.points.position;
            const userPoints = state.points.points;
            const fictionalNames = [
                'Alex Thompson', 'Sarah Chen', 'Mike Rodriguez', 'Emma Wilson',
                'David Park', 'Lisa Johnson', 'Ryan Kumar', 'Sophia Davis',
                'James Miller', 'Olivia Brown', 'Daniel Lee', 'Isabella Garcia',
                'Matthew Anderson', 'Ava Martinez', 'Christopher Taylor',
                'Mia Jackson', 'Andrew White', 'Charlotte Harris', 'Joshua Clark',
                'Amelia Lewis', 'Anthony Young', 'Harper King', 'Nicholas Scott',
                'Evelyn Green', 'Tyler Adams', 'Abigail Baker', 'Jacob Hill',
                'Emily Nelson', 'William Carter', 'Madison Mitchell', 'Ethan Perez',
                'Elizabeth Roberts', 'Alexander Turner', 'Sofia Phillips',
                'Benjamin Campbell', 'Ella Parker', 'Samuel Evans', 'Scarlett Edwards',
                'Logan Collins', 'Chloe Stewart', 'Lucas Sanchez', 'Lily Morris',
                'Jackson Rogers', 'Grace Reed', 'Aiden Cook', 'Zoe Morgan',
                'Elijah Bell', 'Hannah Murphy', 'Gabriel Bailey', 'Nora Rivera',
                'Carter Cooper', 'Lillian Richardson', 'Owen Cox'
            ];
            const entries = [];
            const totalEntries = Math.max(10, userPosition + 5);
            for (let i = 1; i <= totalEntries; i++) {
                if (i === userPosition) {
                    entries.push({
                        position: i,
                        name: state.customer ? (state.customer.person.firstName + ' ' + state.customer.person.lastName) : 'You',
                        points: userPoints,
                        isUser: true
                    });
                }
                else {
                    const nameIndex = (i - 1) % fictionalNames.length;
                    const basePoints = userPoints + (userPosition - i) * Math.floor(Math.random() * 50 + 10);
                    const points = Math.max(0, basePoints + Math.floor(Math.random() * 20 - 10));
                    entries.push({
                        position: i,
                        name: fictionalNames[nameIndex],
                        points: points,
                        isUser: false
                    });
                }
            }
            leaderboardEntries.value = entries;
        }
        onMounted(() => {
            getCustomer(() => {
                getPoints(() => {
                    generateLeaderboard();
                });
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: "🏆 Leader Board",
                        bgcolor: "white"
                    }))
                    : _createCommentVNode("", true),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).points
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).points)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leaderboardEntries.value, (entry, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: _normalizeClass(["leaderboard-entry", {
                                                        'user-entry': entry.isUser,
                                                        'blurred': !entry.isUser,
                                                        'top-position': index < 3 && !entry.isUser
                                                    }])
                                            }, [
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createElementVNode("span", _hoisted_5, _toDisplayString(entry.position), 1),
                                                    (index === 0)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "🥇"))
                                                        : (index === 1 && !entry.isUser)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "🥈"))
                                                            : (index === 2 && !entry.isUser)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "🥉"))
                                                                : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(entry.name), 1),
                                                    _createElementVNode("div", _hoisted_11, _toDisplayString(entry.points) + " points", 1)
                                                ]),
                                                (entry.isUser)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "You"))
                                                    : _createCommentVNode("", true)
                                            ], 2));
                                        }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("p", null, [
                                            _cache[0] || (_cache[0] = _createTextVNode("Your current position: ")),
                                            _createElementVNode("strong", null, "#" + _toDisplayString(_unref(state).points.position), 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                            _cache[1] || (_cache[1] = _createTextVNode("Your points: ")),
                                            _createElementVNode("strong", null, _toDisplayString(_unref(state).points.points), 1)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
